export default "__VITE_ASSET__LkR7856f__"